export default {
  action: 'יצירת משתמש',
  fileTitle: 'משתמשים',
  verifyDeletion: 'האם אתה בטוח שברצונך להעביר את המשתמש לארכיון?',
  deletionReason: 'סיבת המחיקה',
  succesdDelete: 'המשתמש הועבר לארכיון בהצלחה',
  faildDelete: 'לא ניתן להעביר את המשתמש לארכיון אנא נסה שנית',
  notification: {
    title: 'המשתמש הופעל בהצלחה',
    message: 'פרטי המשתמש עודכנו במערכת',
    errors: {
      find: {
        title: 'שגיאה',
        message: 'לא ניתן למצוא משתמשים אנא נסה שנית',
      },
      delete: {
        title: 'שגיאה',
        message: 'לא ניתן למחוק משתמשים אנא נסה שנית',
      },
      export: {
        title: 'שגיאה',
        message: 'לא ניתן לייצא דו"ח',
      },
    },
  },
};
